import { useMemo, useState, type FC } from 'react'
import { Layout } from '@/modules'
import type { PrivateRouteProps } from './types'
import { appStore, useAppSelector } from '@/store'

export const PrivateRoute: FC<PrivateRouteProps> = ({
  auth: { isAuthenticated },
  children,
  path,
}) => {
  const { menuAccess } = useAppSelector(appStore)
  const [root, setRoot] = useState(<></>)

  useMemo(() => {
    if (
      isAuthenticated &&
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      menuAccess?.some((e: any) => path.includes(e.pathname))
    ) {
      setRoot(<Layout>{children}</Layout>)
    }
  }, [menuAccess])

  if (
    isAuthenticated &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    menuAccess?.some((e: any) => path.includes(e.pathname))
  ) {
    return <Layout>{children}</Layout>
  }

  if (!isAuthenticated) {
    window.location.href = '/' // + reload page
  }

  return root
}
